import { render, staticRenderFns } from "./LibreriaBilanciAnalitici.vue?vue&type=template&id=4a4deacc&scoped=true"
import script from "./LibreriaBilanciAnalitici.vue?vue&type=script&lang=js"
export * from "./LibreriaBilanciAnalitici.vue?vue&type=script&lang=js"
import style0 from "./LibreriaBilanciAnalitici.vue?vue&type=style&index=0&id=4a4deacc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4deacc",
  null
  
)

export default component.exports